export default "__VITE_ASSET__5a06a969__"